import { create } from 'zustand';

type ToastKind = 'success' | 'error' | 'info';
interface ToastItem { id: number; kind: ToastKind; message: string }
interface ToastState { items: ToastItem[]; push: (kind: ToastKind, message: string) => void; dismiss: (id: number) => void }

let seq = 0;
const useToastStore = create<ToastState>((set, get) => ({
  items: [],
  push: (kind, message) => {
    const id = ++seq;
    set((s) => ({ items: [...s.items.slice(-2), { id, kind, message }] }));
    setTimeout(() => get().dismiss(id), 3500);
  },
  dismiss: (id) => set((s) => ({ items: s.items.filter((i) => i.id !== id) })),
}));

export const toast = {
  success: (m: string) => useToastStore.getState().push('success', m),
  error: (m: string) => useToastStore.getState().push('error', m),
  info: (m: string) => useToastStore.getState().push('info', m),
};

const dot: Record<ToastKind, string> = { success: 'bg-mint', error: 'bg-danger', info: 'bg-blue' };

export function Toaster() {
  const items = useToastStore((s) => s.items);
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-24 z-[100] flex flex-col items-center gap-2 px-4 md:bottom-6" aria-live="polite">
      {items.map((t) => (
        <div key={t.id} role="status" className="pointer-events-auto flex max-w-md animate-pop items-center gap-3 rounded-md border border-white/10 bg-navy-deep px-4 py-3 text-sm font-medium text-white shadow-floating">
          <span className={`size-2 shrink-0 rounded-full ${dot[t.kind]}`} aria-hidden />
          <span className="whitespace-pre-line">{t.message}</span>
        </div>
      ))}
    </div>
  );
}
